//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import { axiosGet } from '../../axios/axios.js'

function formatTrueFalse (value) {
  if (value) {
    return 'Да'
  } else {
    return 'Нет'
  }
}

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    currentFilterProfiles: {
      type: Array,
      default () {
        return []
      }
    },
    filterUrlParameters: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      loading: false,
      deletedFilterProfiles: [],
      currentFilterProfilesLocal: [],
      columns: [
        {
          name: 'modifiedTime',
          label: 'Дата/время изменения',
          align: 'left',
          field: 'modifiedTime',
          sortable: true,
          format: convertTime
        },
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'global',
          label: 'Глобальный',
          align: 'left',
          field: 'global',
          sortable: true,
          format: formatTrueFalse
        }
      ]
    }
  },
  watch: {
    opened: function (result) {
      if (result) {
        this.deletedFilterProfiles = []
        this.currentFilterProfilesLocal = this.currentFilterProfiles
      }
    }
  },
  created: function () {
    this.currentFilterProfilesLocal = this.currentFilterProfiles
  },
  methods: {
    confirm: function () {
      this.$emit('confirm', this.currentFilterProfilesLocal)
    },
    onClose: function () {
      this.$emit('close')
    },
    onDeleteFilterProfile: function (filterProfile) {
      this.deletedFilterProfiles.push(filterProfile)
      this.currentFilterProfilesLocal = this.currentFilterProfilesLocal
        .filter(p => p.name !== filterProfile.name)
    },
    onApplyFilterProfilesDeletion: function () {
      this.loading = true

      if (this.deletedFilterProfiles.length !== 0) {
        const deletePromises = []

        for (let i = 0; i < this.deletedFilterProfiles.length; i++) {
          const filterProfile = this.deletedFilterProfiles[i]
          const url = '/service/delta/dispatcher/removefilterprofile?' +
                      this.filterUrlParameters +
                      '&name=' + filterProfile.name +
                      '&global=' + filterProfile.global

          deletePromises.push(
            axiosGet({
              url: url,
              onSuccess: () => {},
              onFailure: 'Ошибка удаления профиля фильтрации',
              msgTarget: this
            })
          )
        }

        Promise.all(deletePromises).then(brigades => {
          this.loading = false
          this.confirm()
        })
      }
    }
  }
}

